import React, { useEffect, useState } from 'react';
import { Fragment } from 'react';
import { api } from '../../../_services/api.service';
import { Row, Col, Card, CardBody, CustomInput, Button } from 'reactstrap';
import Loader from 'react-loaders';
import PageTitle from '../../../Layout/AppMain/PageTitle';
import AvForm from 'availity-reactstrap-validation/lib/AvForm';
import AvField from 'availity-reactstrap-validation/lib/AvField';
import { toast } from 'react-toastify';
import AppCache from '../../../_helpers/appCache';
import DatePicker from 'react-datepicker';
import Braintree from '../../../Components/Braintree';
import BraintreePartner from '../../../Components/BraintreePartner';

const PartnerSettings = (props) => {

    let partnerId = parseInt(props.match.params.partnerId);
    let [partner, setPartner] = useState({ partnerID: -1, partnerName: '', description: '', partnerType: '' });
    let [isLoading, setIsLoading] = useState(false);

    let [user, setUser] = useState(null);

    const successToastOpts = {
        autoClose: 3000,
        type: toast.TYPE.SUCCESS,
        hideProgressBar: false
    };

    useEffect(() => {
        if (partnerId > 0) {
            loadData(partnerId);
        }
    }, [])

    const loadData = (pid) => {
        setIsLoading(true);
        api.getPartnerById(pid).then(data => {

            if (data.partnerSubscriptionStartDT == undefined || data.partnerSubscriptionStartDT == null) {
                data.partnerSubscriptionStartDT = new Date(2020, 1, 1);
            } else {
                data.partnerSubscriptionStartDT = new Date(data.partnerSubscriptionStartDT);
            }

            AppCache.setPartner(data.partnerID, data.partnerName);
            setPartner(data);

            loadOwner(data.ownerUserID);

            setIsLoading(false);
        })

    }

    const loadOwner = (id) => {
        api.getUserById(id).then(data => {
            if (data.userSubscriptionStartDT == undefined || data.userSubscriptionStartDT == null) {
                data.userSubscriptionStartDT = new Date(2020, 1, 1);
            } else {
                data.userSubscriptionStartDT = new Date(data.userSubscriptionStartDT);
            }

            setUser(data);

            setIsLoading(false);
        })
    }

    const handleSubmit = (e, errors, values) => {
        if (errors.length == 0) {
            if (partner.partnerID > 0) {
                api.updatePartner(0, partner).then(data => {
                    toast("Partner updated successfuly", successToastOpts);
                });
            } else {
                api.createPartner(0, partner).then(id => {
                    toast("Partner created successfuly", successToastOpts);

                    props.history.replace({
                        pathname: `/partnersettings/${id}`
                    });

                    partnerId = id;

                    loadData(id);
                })
            }
        }
    }

  return (
    <Fragment>
      <PageTitle icon="fas fa-building" heading="Account Settings" />
      {isLoading && <Loader style={{}} type="ball-pulse" active />}
      {!isLoading && partner !== null &&
        <Row style={{ marginBottom: '40px' }}>
          <Col md="6">
            <Card>
              <CardBody>
                {partner.partnerID == -1 &&
                  <AvForm onSubmit={handleSubmit}>
                    <AvField name="partnerName" label="Account Name *" value={partner.partnerName}
                      onChange={(e) => setPartner({ ...partner, partnerName: e.target.value })} placeholder="Enter..." required />

                    <AvField name="firstname" label="First Name *" value={partner.firstName} type="text"
                      onChange={(e) => setPartner({ ...partner, firstName: e.target.value })} placeholder="Enter..." required />

                    <AvField name="lastname" label="Last Name *" value={partner.lastName} type="text"
                      onChange={(e) => setPartner({ ...partner, lastName: e.target.value })} placeholder="Enter..." required />

                    <AvField name="email" label="Email *" value={partner.email} type="text"
                      onChange={(e) => setPartner({ ...partner, email: e.target.value })} placeholder="Enter..." required />

                    <AvField name="pass" label="Password *" value={partner.password} type="password"
                      onChange={(e) => setPartner({ ...partner, password: e.target.value })} placeholder="Enter..." required />

                    <AvField name="description" label="Description" value={partner.description} type="textarea" style={{ height: '100px' }}
                      onChange={(e) => setPartner({ ...partner, description: e.target.value })} placeholder="Enter..." />


                    <Button color='link' className="pull-right" onClick={() => props.history.goBack()}>Cancel</Button>
                    <Button color='primary' type="submit" className="pull-right">Save</Button>
                  </AvForm>
                }
                {partner.partnerID > -1 &&
                  <AvForm onSubmit={handleSubmit}>
                    {user !== null &&
                      <h5>Owner: {user.email}</h5>
                    }
                    <AvField name="partnerName" label="Account Name *" value={partner.partnerName}
                      onChange={(e) => setPartner({ ...partner, partnerName: e.target.value })} placeholder="Enter..." required />

                    <AvField name="description" label="Description" value={partner.description} type="textarea" style={{ height: '100px' }}
                      onChange={(e) => setPartner({ ...partner, description: e.target.value })} placeholder="Enter..." />

                    <div className="form-group">
                      <label>Subscription Type</label>
                      <CustomInput type="select" id="subscriptionType" name="subscriptionTypeSelect" className='form-control'
                        onChange={(e) => setPartner({ ...partner, partnerSubscriptionTypeID: e.target.value })}
                        value={partner.partnerSubscriptionTypeID}>
                        <option value={1}>Full Use</option>
                        <option value={2}>Partner Template Only</option>
                      </CustomInput>
                    </div>

                    <div className="form-group">
                      <label>Status Type</label>
                      <CustomInput type="select" id="subscriptionStatus" name="subscriptionStatusSelect" className='form-control'
                        onChange={(e) => setPartner({ ...partner, partnerSubscriptionStatusID: e.target.value })}
                        value={partner.partnerSubscriptionStatusID}>
                        <option value={0}>Lapsed or Ended</option>
                        <option value={1}>Trial</option>
                        <option value={10}>Good Standing</option>
                      </CustomInput>
                    </div>

                    <div className="form-group">
                      <label>Start Date</label><br />
                      <DatePicker className="form-control"
                        selected={partner.partnerSubscriptionStartDT}
                        onChange={(date) => setPartner({ ...partner, partnerSubscriptionStartDT: date })}
                        placeholderText="Start..."
                      />
                    </div>

                    <AvField name="partnerName" label="General Decision Name" value={partner.decisionName}
                      onChange={(e) => setPartner({ ...partner, decisionName: e.target.value })} placeholder="Enter..."
                    />

                    <div className="form-group">
                      <CustomInput
                        type="checkbox"
                        id="showTutorial"
                        checked={partner.showTutorial}
                        label="Show Tutorial"
                        onChange={(e) => setPartner({ ...partner, showTutorial: e.target.checked })}
                      />
                    </div>

                    <Button color='link' className="pull-right" onClick={() => props.history.goBack()}>Cancel</Button>
                    <Button color='primary' type="submit" className="pull-right">Save</Button>
                  </AvForm>
                }

              </CardBody>
            </Card>
          </Col>
          <Col md="6">
            <BraintreePartner
              user={user}
              history={props.history}
            />
          </Col>
        </Row>

      }
    </Fragment>
  )
}

export default PartnerSettings;